

































import Vue, { PropType } from 'vue';
import { SinglePointPacket, Objective } from '@/models/packet';
import { IconData } from '@/icons';

import Icon from '@/components/Icon.vue';

export default Vue.extend({
  components: {
    Icon
  },

  props: {
    packet: {
      type: Object as PropType<SinglePointPacket>,
      required: true
    }
  },

  computed: {
    objective(): Objective {
      return this.packet.objectives[0];
    },

    name(): string {
      return this.objective.name;
    },

    description(): string {
      return this.objective.description;
    },

    goals(): { key: number; icon: IconData; name: string; color: string }[] {
      const { useOutcomeIcon, iconData: objectiveIconData } = this.objective;

      return this.packet.outcomes
        .filter(out => out.isActive)
        .map(out => ({
          icon: useOutcomeIcon ? out.iconData : objectiveIconData,
          name: out.value,
          color: out.color,
          key: out.outcomeId
        }));
    }
  }
});
